module.exports = __webpack_public_path__ + "img/Dantam Makeover 20.f16582db.jpg";